import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';

@Component({
  selector: 'dialog-edit-workdays',
  templateUrl: './dialog-edit-workdays.component.html',
  styleUrls: ['./dialog-edit-workdays.component.scss']
})
export class DialogEditWorkdaysComponent implements OnInit {
  scheduleGroup: FormGroup;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogEditWorkdaysComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private privateService: PrivateService,
    private refreshScaleLineService: RefreshScalelineService
  ) {
    this.scheduleGroup = this.formBuilder.group({
      id: [0],
      description: [null],
      isRestDay: [false],
      date: [null],
      rampTime1: [null, Validators.required],
      rampTime2: [null, Validators.required],
      rampTime3: [null],
      rampTime4: [null],
      rampTime5: [null],
      rampTime6: [null],
    });
  }

  ngOnInit(): void {
    this.scheduleGroup.patchValue({
      id: this.data.RAMP_workdaysRequests_ID,
      description: this.data.Description,
      isRestDay: this.data.RAMP_isRestDay,
      date: this.data.RAMP_CustomDate,
      rampTime1: this.formatTime(this.data.RAMP_Time1),
      rampTime2: this.formatTime(this.data.RAMP_Time2),
      rampTime3: this.formatTime(this.data.RAMP_Time3),
      rampTime4: this.formatTime(this.data.RAMP_Time4),
      rampTime5: this.formatTime(this.data.RAMP_Time5),
      rampTime6: this.formatTime(this.data.RAMP_Time6),
    });
  }

  private formatTime(value: string | null): string | null {
    if (!value) return null;
    try {
      return formatDate(value, 'h:mm a', 'en-US'); // → "12:00 AM", "8:30 PM" — matches ngxTimepicker output
    } catch {
      return null;
    }
  }

  submitWorkdays() {
    this.isLoading = true;
    this.privateService.editWorkdaysRequest(this.scheduleGroup.value).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshScaleLineService.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

}
